// Dvir related config
import {getEnvironmentConfig} from './dvir/config'
import {getChatConfig} from '@peoplenet/tfm-shared/chat/config'
import {getEldConfig} from '@peoplenet/tfm-shared/eldUi/config'
import {getOrgManagementConfig} from '@peoplenet/tfm-shared/orgManagement/config'
import {getRemoteLogoutConfig} from '@peoplenet/tfm-shared/remoteLogout/config'
import {getOEMConfig} from '@peoplenet/tfm-shared/oemGateways/config'
import {getNewsFeedConfig} from '@peoplenet/tfm-shared/newsFeed/config'
import {getPSConfig} from '@peoplenet/tfm-shared/psEld/psConfig'
import {getRpcConfigUrl} from '@peoplenet/tfm-shared/rpc/config'

window.dvirEnvUrl = getEnvironmentConfig()
window.chatEnvUrl = getChatConfig()
window.eldEnvUrl = getEldConfig()
window.orgManagementUrl = getOrgManagementConfig()
window.remoteLogoutEnvUrl = getRemoteLogoutConfig()
window.oemEnvUrl = getOEMConfig()
window.newsFeedEnvUrl = getNewsFeedConfig()
window.psEnvUrl = getPSConfig()
window.rpcConfigEnvUrl = getRpcConfigUrl()

import('./bootstrap')
